
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radio/[id]",
      function () {
        return require("private-next-pages/radio/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/radio/[id]"])
      });
    }
  